<div class="metricas-container">
  <!-- Barra de filtros: período (las métricas persistidas se agregan por
       franja horaria) y acciones de la página -->
  <app-dashboard-filtros titulo="Métricas de downlinks">
    <app-date-picker
      filtros-periodo
      mode="daterange"
      label="Período"
      [maxDate]="hoyPeriodo"
      [(ngModel)]="rangoPeriodo"
      (ngModelChange)="onRangoPeriodoChange($event)"
    ></app-date-picker>

    @if (ultimaActualizacion) {
      <span filtros-acciones class="last-update">
        Actualizado {{ ultimaActualizacion | date: 'HH:mm:ss' }}
      </span>
    }
    @if (loading) {
      <mat-spinner filtros-acciones diameter="20" />
    }
    <!-- El resumen del período es una tabla de números: vive detrás de este
         botón para no ocupar media pantalla del dashboard. -->
    @if (hayResumen) {
      <button
        irxBotonIcono
        filtros-acciones
        (click)="abrirResumen()"
        tooltip="Ver resumen del período"
      >
        <mat-icon>fact_check</mat-icon>
      </button>
    }
    <!-- Informe PDF de lo que se está viendo (mismo período del filtro). -->
    <button
      irxBotonIcono
      filtros-acciones
      (click)="descargarPdf()"
      [disabled]="generandoPdf || loading"
      tooltip="Descargar informe del período (PDF)"
    >
      <mat-icon>picture_as_pdf</mat-icon>
    </button>
    <button
      irxBotonIcono
      filtros-acciones
      (click)="refresh()"
      [disabled]="loading"
      tooltip="Actualizar métricas"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </app-dashboard-filtros>

  @if (error) {
    <div class="error-banner">
      <mat-icon>warning</mat-icon>
      {{ error }}
    </div>
  }

  @if (!estado) {
    @if (loading) {
      <div class="dpanel-vacio">
        <mat-spinner diameter="36"></mat-spinner>
        <p>Cargando métricas de downlinks…</p>
      </div>
    } @else if (!error) {
      <div class="dpanel-vacio">
        <mat-icon>inbox</mat-icon>
        <p>No hay métricas de downlinks para mostrar.</p>
      </div>
    }
  } @else {
    <!-- ========================================================== -->
    <!-- SECUENCIADOR                                                -->
    <!-- ========================================================== -->
    <app-dashboard-panel
      titulo="Secuenciador de Downlinks"
      icono="playlist_play"
    >
      <app-metrica-help panel-acciones intro="" [items]="helpSecuenciador" />
      <div class="card-body">
        <div class="stat-grid">
          <app-stat-card
            title="Planes creados"
            [value]="getTotal('seq_planes_creados_total')"
            icon="playlist_add"
            color="teal"
          />
          <app-stat-card
            title="Completados"
            [value]="getTotal('seq_planes_completados_total')"
            icon="check_circle"
            color="green"
          />
          <app-stat-card
            title="Salteados"
            [value]="getTotal('seq_planes_saltados_total')"
            icon="skip_next"
            color="yellow"
          />
          <app-stat-card
            title="Abortados"
            [value]="getTotal('seq_planes_abortados_total')"
            icon="cancel"
            color="red"
          />
          <app-stat-card
            title="Pasos reintentados"
            [value]="getTotal('seq_pasos_reintentados_total')"
            icon="replay"
            color="orange"
          />
          <app-stat-card
            title="Pasos forzados"
            [value]="getTotal('seq_pasos_forzados_total')"
            icon="fast_forward"
            color="yellow"
          />
          <app-stat-card
            title="Fallos al encolar"
            [value]="getTotal('seq_add_fallido_total')"
            icon="error_outline"
            color="red"
          />
          <app-stat-card
            title="Reemplazados (deseada cambió)"
            [value]="getTotal('seq_planes_reemplazados_version_total')"
            icon="published_with_changes"
            color="purple"
          />
        </div>
        <div class="metricas-chart chart-pair">
          <div class="chart-cell">
            <h4>Planes y pasos por franja</h4>
            @if (hayCharts && conValores(chSeq)) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="line"
                [series]="chSeq"
                [categorias]="catFranjas"
                tituloEjeY="Cantidad"
                altura="260px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>playlist_play</mat-icon>
                <p>Sin planes ni pasos en el período.</p>
              </div>
            }
          </div>
          <div class="chart-cell">
            <h4>Latencia SET → confirmación (distribución)</h4>
            @if (hayLatenciaV) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="column"
                [series]="latenciaData"
                [categorias]="latenciaCats"
                [colorPaleta]="paletaBarras"
                tituloEjeY="Confirmaciones"
                [mostrarLeyenda]="false"
                altura="260px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>timer</mat-icon>
                <p>Sin confirmaciones con latencia medida en el período.</p>
              </div>
            }
          </div>
        </div>
        <div class="config-grid config-grid-wide">
          <div class="config-item">
            <span class="config-label">Timeout ACK</span>
            <span class="config-value">
              {{ config?.secuenciador?.deadlineAckSec }} s
            </span>
          </div>
          <div class="config-item">
            <span class="config-label">Timeout uplink (get)</span>
            <span class="config-value">
              {{ config?.secuenciador?.deadlineEcoSec }} s
            </span>
          </div>
          <div class="config-item">
            <span class="config-label">Máx. reintentos por paso</span>
            <span class="config-value">
              {{ config?.secuenciador?.maxReintentosPaso }}
            </span>
          </div>
          <div class="config-item">
            <span class="config-label">TTL del plan</span>
            <span class="config-value">
              {{ config?.secuenciador?.planTtlSec }} s
            </span>
          </div>
          <div class="config-item">
            <span class="config-label">Buffer de envío</span>
            <span class="config-value">
              {{ config?.secuenciador?.sendBufferSec }} s
            </span>
          </div>
        </div>
      </div>
    </app-dashboard-panel>

    <!-- ========================================================== -->
    <!-- CUPOS POR GATEWAY                                           -->
    <!-- El recurso que se satura es el gateway, y el cupo es la     -->
    <!-- perilla: verlo EN EL TIEMPO es lo que dice si el            -->
    <!-- controlador aprendió, si oscila o si está clavado en el     -->
    <!-- piso. Por eso va a todo el ancho, con la serie temporal     -->
    <!-- arriba de la tabla.                                         -->
    <!-- ========================================================== -->
    <app-dashboard-panel titulo="Cupos por gateway" icono="podcasts">
      <app-metrica-help
        panel-acciones
        intro="El cupo es la cantidad de planes que pueden estar en vuelo a la vez en un gateway. El controlador lo sube o lo baja según la tasa de fallo de ese mismo gateway."
        [items]="helpCongestion"
      />
      <div class="card-body">
        <div class="meta-row">
          <span
            class="status-badge"
            [class.badge-active]="config?.congestion?.enabled"
            [class.badge-inactive]="!config?.congestion?.enabled"
          >
            {{ config?.congestion?.enabled ? 'ACTIVO' : 'INACTIVO' }}
          </span>
        </div>
        @if (hayCharts && gwHeatCats.length) {
          <!-- Heatmap y no líneas: con muchos gateways una serie por cada uno
               es ilegible, y lo que se busca es el patrón (qué gateway está en
               el piso y en qué franja). -->
          <div class="metricas-chart">
            <h4>Cupo por gateway y franja</h4>
            <app-graficos
              [pantallaCompleta]="true"
              tipo="heatmap"
              [datosHeatmap]="chCupoHeat"
              [categorias]="catFranjas"
              [categoriasY]="gwHeatCats"
              altura="320px"
            ></app-graficos>
          </div>
          <div class="metricas-chart">
            <h4>Tasa de fallo (%) por gateway y franja</h4>
            <app-graficos
              [pantallaCompleta]="true"
              tipo="heatmap"
              [datosHeatmap]="chTasaFalloHeat"
              [categorias]="catFranjas"
              [categoriasY]="gwHeatCats"
              altura="280px"
            ></app-graficos>
          </div>
        } @else {
          <!-- Sin historial de cupo el heatmap no se dibuja. Se dice por qué:
               si no, parece que el gráfico no existiera. -->
          <div class="dpanel-vacio vacio-compacto">
            <mat-icon>cell_tower</mat-icon>
            <p>
              Sin historial de cupo en el período.
              @if (!config?.congestion?.enabled) {
                El control de congestión está inactivo: no hay cupos que seguir.
              } @else {
                Todavía no hay franjas con muestras del controlador.
              }
            </p>
          </div>
        }
        @if (filasGatewayV.length) {
          <div class="tabla-scroll">
            <table class="tabla-gateways">
              <thead>
                <tr>
                  <th>Gateway</th>
                  <th>Cupo</th>
                  <th>Rango del período</th>
                  <th>Ocupación</th>
                  <th>Tasa de fallo</th>
                  <th>ACK false</th>
                  <th>Esperando cupo</th>
                  <th>Fugas</th>
                </tr>
              </thead>
              <tbody>
                @for (g of filasGatewayV; track g.gw) {
                  <tr>
                    <td>
                      {{ g.nombre ?? g.gw }}
                      @if (g.nombre) {
                        <div class="mono-sub">{{ g.gw }}</div>
                      }
                    </td>
                    <td>{{ g.cupo }}</td>
                    <td>
                      {{ g.cupoMin }} – {{ g.cupoMax }}
                      @if (g.cupoMin === g.cupoMax && g.cupoMin > 0) {
                        <div class="mono-sub">estable</div>
                      }
                    </td>
                    <td>{{ g.ocupacion }} / {{ g.cupo }}</td>
                    <td>{{ g.tasaFalloPct }} %</td>
                    <td>
                      {{ g.ackFalsePct }} %
                      <div class="mono-sub">
                        {{ g.ackFalse }} / {{ g.ackOk + g.ackFalse }}
                      </div>
                    </td>
                    <!-- Dos lecturas de lo MISMO: cuántos planes están
                         esperando cupo en este momento, y cuántas veces a lo
                         largo del período un plan no pudo arrancar por falta de
                         cupo (acumulado). -->
                    <td>
                      {{ g.enEspera }} ahora
                      <div class="mono-sub">
                        {{ g.diferidos }} veces en el período
                      </div>
                    </td>
                    <td>{{ g.fugas }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="dpanel-vacio vacio-compacto">
            <mat-icon>podcasts</mat-icon>
            <p>Sin actividad por gateway en el período.</p>
          </div>
        }
        <!-- Sólo si el backend expone la config del controlador: un
             gestion-cron viejo no trae el bloque `congestion` y el panel queda
             como un esqueleto de etiquetas sin valores. -->
        @if (config?.congestion) {
          <div class="config-grid config-grid-wide">
            <div class="config-item">
              <span class="config-label">Cupo inicial</span>
              <span class="config-value">
                {{ config?.congestion?.cupoInicial }}
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Rango permitido</span>
              <span class="config-value">
                {{ config?.congestion?.cupoMin }} –
                {{ config?.congestion?.cupoMax }}
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">
                Umbrales (subir / bajar / protección)
              </span>
              <span class="config-value">
                {{ config?.congestion?.umbralSubirPct }} % /
                {{ config?.congestion?.umbralBajarPct }} % /
                {{ config?.congestion?.umbralProteccionPct }} %
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Ventana / cooldown</span>
              <span class="config-value">
                {{ config?.congestion?.ventanaSeg }} s
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Mínimo de muestras</span>
              <span class="config-value">
                {{ config?.congestion?.minMuestras }}
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Memoria del cupo aprendido</span>
              <span class="config-value">
                {{ config?.congestion?.memoriaSeg }} s
              </span>
            </div>
          </div>
        }
      </div>
    </app-dashboard-panel>

    <!-- Resto de secciones en masonry (columnas): empaquetan sin dejar huecos
         de fila como el grid 2-col. El Secuenciador queda full-width arriba. -->
    <div class="cards-masonry">
      <!-- ========================================================== -->
      <!-- CONFIRMACIÓN (ACK / uplink) — métrica nueva                 -->
      <!-- ========================================================== -->
      <app-dashboard-panel
        class="full-span"
        titulo="Confirmación (ACK / uplink)"
        icono="verified"
      >
        <app-metrica-help
          panel-acciones
          intro="Cómo se confirman los downlinks: ACK del dispositivo en los SET y uplinks de configuración en los auto-GET. El ACK false es el síntoma directo de problemas de bajada."
          [items]="helpConfirmacion"
        />
        <div class="card-body">
          <div class="stat-grid">
            <app-stat-card
              title="ACK true"
              [value]="getTotal('seq_ack_ok_total')"
              icon="check_circle"
              color="green"
            />
            <app-stat-card
              title="ACK false"
              [value]="getTotal('seq_ack_timeout_total')"
              icon="cancel"
              color="red"
            />
            <app-stat-card
              title="Uplink ok"
              [value]="getTotal('seq_autoget_eco_ok_total')"
              icon="done_all"
              color="teal"
            />
            <app-stat-card
              title="Uplink timeout"
              [value]="getTotal('seq_autoget_eco_timeout_total')"
              icon="timer_off"
              color="yellow"
            />
          </div>
          <div class="metricas-chart">
            <h4>Embudo de confirmación</h4>
            @if (hayFunnelV) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="bar"
                [series]="funnelData"
                [categorias]="funnelCats"
                [colorPaleta]="paletaBarras"
                [mostrarLeyenda]="false"
                altura="240px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>filter_alt</mat-icon>
                <p>Sin envíos para armar el embudo en el período.</p>
              </div>
            }
          </div>
          @if (hayCharts && conValores(chConfirm)) {
            <div class="metricas-chart chart-pair">
              <div class="chart-cell">
                <h4>Confirmación por franja</h4>
                <app-graficos
                  [pantallaCompleta]="true"
                  tipo="line"
                  [series]="chConfirm"
                  [categorias]="catFranjas"
                  tituloEjeY="Cantidad"
                  altura="260px"
                ></app-graficos>
              </div>
              <div class="chart-cell">
                <h4>ACK false ratio (%)</h4>
                <app-graficos
                  [pantallaCompleta]="true"
                  tipo="line"
                  [series]="chAckRatio"
                  [categorias]="catFranjas"
                  tituloEjeY="%"
                  [mostrarLeyenda]="false"
                  altura="260px"
                ></app-graficos>
              </div>
            </div>
          } @else {
            <div class="metricas-chart">
              <h4>Confirmación por franja</h4>
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>verified</mat-icon>
                <p>Sin confirmaciones en el período.</p>
              </div>
            </div>
          }
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">Persistencia de métricas</span>
              <span
                class="status-badge"
                [class.badge-active]="config?.metricasCron?.enabled"
                [class.badge-inactive]="!config?.metricasCron?.enabled"
              >
                {{ config?.metricasCron?.enabled ? 'ACTIVA' : 'INACTIVA' }}
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Cron de cierre</span>
              <code class="config-value">{{ config?.metricasCron?.cron }}</code>
            </div>
            <div class="config-item">
              <span class="config-label">Retención en Redis</span>
              <span class="config-value">
                {{ (config?.metricasCron?.redisTtlSeg || 0) / 86400 }} días
              </span>
            </div>
          </div>
        </div>
      </app-dashboard-panel>

      <!-- ========================================================== -->
      <!-- FILA BULLMQ                                                 -->
      <!-- ========================================================== -->
      <app-dashboard-panel titulo="Estado de la Fila BullMQ" icono="inbox">
        <app-metrica-help
          panel-acciones
          intro="Estado de la fila BullMQ que orquesta el envío de downlinks a las luminarias."
          [items]="helpCola"
        />
        <div class="card-body">
          <div class="stat-grid">
            <app-stat-card
              title="En espera"
              [value]="queueSize('waiting')"
              icon="pending"
              color="yellow"
            />
            <app-stat-card
              title="Programados"
              [value]="queueSize('delayed')"
              icon="schedule"
              color="teal"
            />
            <app-stat-card
              title="Procesando"
              [value]="queueSize('active')"
              icon="sync"
              color="blue"
            />
            <app-stat-card
              title="Completados"
              [value]="queueSize('completed')"
              icon="check_circle"
              color="green"
            />
            <app-stat-card
              title="Fallidos"
              [value]="queueSize('failed')"
              icon="error"
              color="red"
            />
          </div>
          <div class="metricas-chart">
            <h4>Tamaño de fila por franja</h4>
            @if (hayCharts && conValores(chCola)) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="area"
                [series]="chCola"
                [categorias]="catFranjas"
                tituloEjeY="Jobs"
                [mostrarLeyenda]="false"
                altura="260px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>inbox</mat-icon>
                <p>Sin jobs en la fila durante el período.</p>
              </div>
            }
          </div>
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">Queue name</span>
              <code class="config-value">
                {{ config?.secuenciador?.queueName }}
              </code>
            </div>
            <div class="config-item">
              <span class="config-label">Concurrencia</span>
              <span class="config-value">
                {{ config?.secuenciador?.concurrency }} workers
              </span>
            </div>
          </div>
        </div>
      </app-dashboard-panel>

      <!-- ========================================================== -->
      <!-- ENVÍOS POR ORIGEN                                          -->
      <!-- ========================================================== -->
      <app-dashboard-panel titulo="Envíos por Origen" icono="send">
        <app-metrica-help
          panel-acciones
          intro="Downlinks acumulados según de dónde salieron y cómo terminaron."
          [items]="helpOrigen"
        />
        <div class="card-body">
          <table class="metricas-table">
            <thead>
              <tr>
                <th>Origen / Nivel</th>
                <th class="align-right col-sent">
                  <mat-icon>check_circle</mat-icon>
                  Enviados
                </th>
                <th class="align-right col-discarded">
                  <mat-icon>block</mat-icon>
                  Descartados
                </th>
                <th class="align-right col-failed">
                  <mat-icon>error_outline</mat-icon>
                  Fallidos
                </th>
              </tr>
            </thead>
            <tbody>
              @for (fila of filasOrigenV; track fila.label) {
                <tr>
                  <td class="origen-cell">{{ fila.label }}</td>
                  <td class="align-right col-sent">
                    {{ sumSample('downlinks_sent_total', fila.match) }}
                  </td>
                  <td class="align-right col-discarded">
                    {{ sumSample('downlinks_descartados_total', fila.match) }}
                  </td>
                  <td class="align-right col-failed">
                    {{ sumSample('downlinks_failed_total', fila.match) }}
                  </td>
                </tr>
              }
            </tbody>
            <tfoot>
              <tr class="total-row">
                <td>Total</td>
                <td class="align-right col-sent">
                  {{ getTotal('downlinks_sent_total') }}
                </td>
                <td class="align-right col-discarded">
                  {{ getTotal('downlinks_descartados_total') }}
                </td>
                <td class="align-right col-failed">
                  {{ getTotal('downlinks_failed_total') }}
                </td>
              </tr>
            </tfoot>
          </table>
          <div class="metricas-chart">
            <h4>Envíos por franja</h4>
            @if (hayCharts && conValores(chSent)) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="column"
                [series]="chSent"
                [categorias]="catFranjas"
                tituloEjeY="Downlinks"
                altura="280px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>send</mat-icon>
                <p>Sin envíos en el período.</p>
              </div>
            }
          </div>
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">expiresAt manual</span>
              <span class="config-value">
                {{ config?.secuenciador?.expiresMinManual }} min
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">expiresAt reconciliación</span>
              <span class="config-value">
                {{ config?.secuenciador?.expiresMinReconciliacion }} min
              </span>
            </div>
          </div>
        </div>
      </app-dashboard-panel>

      <!-- ========================================================== -->
      <!-- RATE LIMITING                                               -->
      <!-- ========================================================== -->
      <app-dashboard-panel titulo="Rate Limiting" icono="speed">
        <app-metrica-help
          panel-acciones
          intro="Jerarquía de throttling que regula a qué ritmo salen los downlinks. Cuando un job choca con un límite NO se pierde: se reprograma con un pequeño retraso."
          [items]="helpRateLimit"
        />
        <div class="card-body">
          <div class="big-metric">
            <span class="big-num orange">
              {{ getTotal('downlinks_rate_limited_total') }}
            </span>
            <span class="big-label">jobs reprogramados acumulados</span>
          </div>
          @let rateItems = rateLimitItemsV;
          @if (rateItems.length > 0) {
            <div class="rate-scope-list">
              <div class="breakdown-header">
                Reprogramaciones por nivel de throttle
                <span class="breakdown-count">{{ rateItems.length }}</span>
              </div>
              <div class="rate-scope-scroll">
                @for (
                  it of rateItems;
                  track it.titulo + (it.identificador ?? '')
                ) {
                  <div class="rate-scope-item">
                    <div class="rate-scope-icon" [ngClass]="'scope-' + it.tipo">
                      <mat-icon>{{ it.icono }}</mat-icon>
                    </div>
                    <div class="rate-scope-info">
                      <div class="rate-scope-top">
                        <span
                          class="rate-scope-badge"
                          [ngClass]="'scope-' + it.tipo"
                        >
                          {{ it.titulo }}
                        </span>
                        @if (it.nombre) {
                          <span class="rate-scope-nombre">{{ it.nombre }}</span>
                        }
                      </div>
                      @if (it.identificador) {
                        <code class="rate-scope-eui" [class.muted]="it.nombre">
                          {{ it.identificador }}
                        </code>
                      }
                      <div class="rate-scope-bar">
                        <span
                          [ngClass]="'scope-' + it.tipo"
                          [style.width.%]="it.pct"
                        ></span>
                      </div>
                    </div>
                    <span class="rate-scope-value">{{ it.value }}</span>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="dpanel-vacio vacio-compacto">
              <mat-icon>speed</mat-icon>
              <p>Sin reprogramaciones por rate limit en el período.</p>
            </div>
          }
          <!-- Sin reprogramaciones el heatmap queda vacío: el aviso de arriba
               ya lo dice -->
          @if (hayCharts && rateItems.length > 0) {
            <div class="metricas-chart">
              <h4>Rebotes por franja y limiter</h4>
              <app-graficos
                [pantallaCompleta]="true"
                tipo="heatmap"
                [datosHeatmap]="chRlHeatmap"
                [categorias]="catFranjas"
                [categoriasY]="rlScopesLabels"
                altura="280px"
              ></app-graficos>
            </div>
          }
          @if (hayLuminariasRlV) {
            <div class="metricas-chart">
              <h4>Luminarias afectadas por limiter</h4>
              <app-graficos
                [pantallaCompleta]="true"
                tipo="bar"
                [series]="luminariasRlData"
                [categorias]="luminariasRlCatsV"
                [colorPaleta]="paletaBarras"
                [mostrarLeyenda]="false"
                altura="220px"
              ></app-graficos>
            </div>
          }
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">Rate global</span>
              <span class="config-value">
                {{ config?.secuenciador?.rateGlobalPerSec }} / seg
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Rate por gateway</span>
              <span class="config-value">
                mín. {{ config?.secuenciador?.ratePerGwMs }} ms
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Rate sin gateway</span>
              <span class="config-value">
                mín. {{ config?.secuenciador?.rateNoGwSec }} seg
              </span>
            </div>
          </div>
        </div>
      </app-dashboard-panel>

      <!-- ========================================================== -->
      <!-- RECONCILIADOR                                               -->
      <!-- ========================================================== -->
      <app-dashboard-panel
        class="full-span"
        titulo="Reconciliador"
        icono="compare_arrows"
      >
        <app-metrica-help
          panel-acciones
          intro="Cron que compara la configuración deseada de cada dispositivo contra la real y reenvía lo que no se aplicó."
          [items]="helpReconciliador"
        />
        <div class="card-body">
          <div class="meta-row">
            <span
              class="status-badge"
              [class.badge-active]="config?.reconciliador?.enabled"
              [class.badge-inactive]="!config?.reconciliador?.enabled"
            >
              {{ config?.reconciliador?.enabled ? 'ACTIVO' : 'INACTIVO' }}
            </span>
          </div>
          <div class="stat-grid">
            <app-stat-card
              title="Ejecuciones"
              [value]="getTotal('reconciliation_runs_total')"
              icon="replay"
              color="purple"
            />
            <app-stat-card
              title="Divergencias"
              [value]="getTotal('reconciliation_diffs_found_total')"
              icon="find_replace"
              color="yellow"
            />
            <app-stat-card
              title="Bloqueados"
              [value]="getTotal('reconciliation_blocked_devices_total')"
              icon="lock"
              color="red"
            />
            <app-stat-card
              title="Offline omitidos"
              [value]="getTotal('reconciliation_skipped_offline_total')"
              icon="cloud_off"
              color="yellow"
            />
            <app-stat-card
              title="Nocturna omitidos"
              [value]="getTotal('reconciliation_skipped_nocturna_total')"
              icon="bedtime"
              color="purple"
            />
          </div>
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">Cron</span>
              <code class="config-value">
                {{ config?.reconciliador?.cron }}
              </code>
            </div>
            <div class="config-item">
              <span class="config-label">Batch size</span>
              <span class="config-value">
                {{ config?.reconciliador?.batchSize }} dispositivos
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Máx. reintentos</span>
              <span class="config-value">
                {{ config?.reconciliador?.backoffIntentos }}
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Bloqueo al exceder</span>
              <span class="config-value">
                {{ config?.reconciliador?.bloqueoHoras }} hs
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Deseadas al cierre</span>
              <span class="config-value">
                {{
                  gaugeUltimo('reconciliation_configs_estado', {
                    estado: 'Coincide',
                  })
                }}
                coinciden ·
                {{
                  gaugeUltimo('reconciliation_configs_estado', {
                    estado: 'No coincide',
                  })
                }}
                no ·
                {{
                  gaugeUltimo('reconciliation_configs_estado', {
                    estado: 'Pendiente',
                  })
                }}
                pendientes
              </span>
            </div>
          </div>
          <div class="metricas-chart chart-pair">
            <div class="chart-cell">
              <h4>Reconciliador por franja</h4>
              @if (hayCharts && conValores(chRecon)) {
                <app-graficos
                  [pantallaCompleta]="true"
                  tipo="line"
                  [series]="chRecon"
                  [categorias]="catFranjas"
                  tituloEjeY="Configuraciones"
                  altura="260px"
                ></app-graficos>
              } @else {
                <div class="dpanel-vacio vacio-compacto">
                  <mat-icon>compare_arrows</mat-icon>
                  <p>Sin actividad del reconciliador en el período.</p>
                </div>
              }
            </div>
            <div class="chart-cell">
              <h4>Tiempo a convergencia (divergencia → coincide)</h4>
              @if (hayConvergenciaV) {
                <app-graficos
                  [pantallaCompleta]="true"
                  tipo="column"
                  [series]="convergenciaData"
                  [categorias]="convergenciaCats"
                  [colorPaleta]="paletaBarras"
                  tituloEjeY="Configuraciones"
                  [mostrarLeyenda]="false"
                  altura="260px"
                ></app-graficos>
              } @else {
                <div class="dpanel-vacio vacio-compacto">
                  <mat-icon>hourglass_empty</mat-icon>
                  <p>Sin configuraciones convergidas en el período.</p>
                </div>
              }
            </div>
          </div>
        </div>
      </app-dashboard-panel>

      <!-- ========================================================== -->
      <!-- REINTENTOS DESCARTADOS                                      -->
      <!-- ========================================================== -->
      <app-dashboard-panel titulo="Reintentos de Descartados" icono="redo">
        <app-metrica-help
          panel-acciones
          intro="Cron que reencola comandos de control (Encender, Apagar, Reset, GPS) que se descartaron por dispositivo offline."
          [items]="helpReintentos"
        />
        <div class="card-body">
          <div class="meta-row">
            <span
              class="status-badge"
              [class.badge-active]="config?.reintentosDescartados?.enabled"
              [class.badge-inactive]="!config?.reintentosDescartados?.enabled"
            >
              {{
                config?.reintentosDescartados?.enabled ? 'ACTIVO' : 'INACTIVO'
              }}
            </span>
          </div>
          <div class="big-metric">
            <span class="big-num orange">
              {{ getTotal('reintentos_descartados_total') }}
            </span>
            <span class="big-label">
              comandos manuales descartados reencolados
            </span>
          </div>
          <div class="metricas-chart">
            <h4>Reencolados por franja</h4>
            @if (hayCharts && conValores(chReintentos)) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="line"
                [series]="chReintentos"
                [categorias]="catFranjas"
                tituloEjeY="Comandos"
                [mostrarLeyenda]="false"
                altura="240px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>redo</mat-icon>
                <p>Sin comandos reencolados en el período.</p>
              </div>
            }
          </div>
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">Cron</span>
              <code class="config-value">
                {{ config?.reintentosDescartados?.cron }}
              </code>
            </div>
            <div class="config-item">
              <span class="config-label">Ventana de búsqueda</span>
              <span class="config-value">
                {{ config?.reintentosDescartados?.ventanaMin }} min
              </span>
            </div>
          </div>
        </div>
      </app-dashboard-panel>

      <!-- ========================================================== -->
      <!-- BARRIDO DE COMANDOS SIN CONFIRMAR                          -->
      <!-- ========================================================== -->
      <app-dashboard-panel
        titulo="Barrido de Comandos sin Confirmar"
        icono="cleaning_services"
      >
        <app-metrica-help
          panel-acciones
          intro="Cron de respaldo que marca 'No Ejecutado' los comandos que quedaron sin confirmación del dispositivo."
          [items]="helpBarridoComandos"
        />
        <div class="card-body">
          <div class="meta-row">
            <span
              class="status-badge"
              [class.badge-active]="config?.barridoComandos?.enabled"
              [class.badge-inactive]="!config?.barridoComandos?.enabled"
            >
              {{ config?.barridoComandos?.enabled ? 'ACTIVO' : 'INACTIVO' }}
            </span>
          </div>
          <div class="big-metric">
            <span class="big-num blue">
              {{ getTotal('comandos_barridos_no_ejecutado_total') }}
            </span>
            <span class="big-label">
              comandos marcados 'No Ejecutado' por el barrido
            </span>
          </div>
          <div class="metricas-chart">
            <h4>Marcados 'No Ejecutado' por franja</h4>
            @if (hayCharts && conValores(chBarrido)) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="line"
                [series]="chBarrido"
                [categorias]="catFranjas"
                tituloEjeY="Comandos"
                [mostrarLeyenda]="false"
                altura="240px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>cleaning_services</mat-icon>
                <p>Sin comandos marcados 'No Ejecutado' en el período.</p>
              </div>
            }
          </div>
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">Cron</span>
              <code class="config-value">
                {{ config?.barridoComandos?.cron }}
              </code>
            </div>
            <div class="config-item">
              <span class="config-label">Umbral sin confirmar</span>
              <span class="config-value">
                {{ (config?.barridoComandos?.timeoutMs || 0) / 1000 }} s
              </span>
            </div>
          </div>
        </div>
      </app-dashboard-panel>

      <!-- ========================================================== -->
      <!-- CONSULTA DE CONFIGURACIÓN INICIAL                          -->
      <!-- ========================================================== -->
      <app-dashboard-panel
        titulo="Consulta de Configuración Inicial"
        icono="settings_input_antenna"
      >
        <app-metrica-help
          panel-acciones
          intro="Cron que hace la consulta inicial de configuración en luminarias que nunca tuvieron perfil."
          [items]="helpConsultaConfig"
        />
        <div class="card-body">
          <div class="meta-row">
            <span
              class="status-badge"
              [class.badge-active]="config?.consultaConfig?.enabled"
              [class.badge-inactive]="!config?.consultaConfig?.enabled"
            >
              {{ config?.consultaConfig?.enabled ? 'ACTIVO' : 'INACTIVO' }}
            </span>
          </div>
          <div class="stat-grid">
            <app-stat-card
              title="Ejecuciones"
              [value]="getTotal('consulta_config_runs_total')"
              icon="replay"
              color="teal"
            />
            <app-stat-card
              title="Consultados"
              [value]="getTotal('consulta_config_consultados_total')"
              icon="settings_input_antenna"
              color="green"
            />
            <app-stat-card
              title="Bloqueados"
              [value]="getTotal('consulta_config_bloqueados_total')"
              icon="lock"
              color="red"
            />
            <app-stat-card
              title="Offline omitidos"
              [value]="getTotal('consulta_config_offline_total')"
              icon="cloud_off"
              color="yellow"
            />
          </div>
          <div class="config-grid">
            <div class="config-item">
              <span class="config-label">Cron</span>
              <code class="config-value">
                {{ config?.consultaConfig?.cron }}
              </code>
            </div>
            <div class="config-item">
              <span class="config-label">Batch size</span>
              <span class="config-value">
                {{ config?.consultaConfig?.batchSize }} luminarias
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Máx. reintentos</span>
              <span class="config-value">
                {{ config?.consultaConfig?.backoffIntentos }}
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Bloqueo al exceder</span>
              <span class="config-value">
                {{ config?.consultaConfig?.bloqueoHoras }} hs
              </span>
            </div>
            <div class="config-item">
              <span class="config-label">Intervalo mínimo</span>
              <span class="config-value">
                {{ config?.consultaConfig?.minIntervaloHoras }} hs
              </span>
            </div>
          </div>
          <div class="metricas-chart">
            <h4>Consulta config por franja</h4>
            @if (hayCharts && conValores(chConsulta)) {
              <app-graficos
                [pantallaCompleta]="true"
                tipo="line"
                [series]="chConsulta"
                [categorias]="catFranjas"
                tituloEjeY="Dispositivos"
                altura="280px"
              ></app-graficos>
            } @else {
              <div class="dpanel-vacio vacio-compacto">
                <mat-icon>settings_input_antenna</mat-icon>
                <p>Sin consultas de configuración en el período.</p>
              </div>
            }
          </div>
        </div>
      </app-dashboard-panel>
    </div>
    <!-- /cards-masonry -->
  }
</div>
